import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRecentArticlesQuery } from '../../../modules/customer/queries';
import { GridContainer, GridItem } from '../../../visual-components/grid/grid';
import { ProductCard } from '../../../visual-components/product-card/product-card';
import { SectionHeader } from '../../../visual-components/section-header/section-header';
import { ProductCardSectionLayout } from '../../../visual-components/product-card-section-layout/product-card-section-layout';
import { InPageLoader } from '../../../visual-components/in-page-loader/in-page-loader';
import { SectionWrapper } from './section-wrapper';

const LOADED_RECENT_ARTICLES = 12;

export const RecentArticles: React.FC = () => {
  const { t } = useTranslation();

  const {
    data: recentArticlesData,
    isLoading: isLoadingRecentArticles,
    isError: hasRecentArticlesError,
    error: recentArticlesError,
  } = useRecentArticlesQuery(LOADED_RECENT_ARTICLES);

  const { items: recentArticles } = recentArticlesData ?? { items: [] };

  return (
    <>
      {isLoadingRecentArticles && recentArticles.length === 0 ? (
        <SectionWrapper>
          <GridContainer>
            <GridItem>
              <InPageLoader />
            </GridItem>
          </GridContainer>
        </SectionWrapper>
      ) : null}
      {recentArticles.length > 0 || hasRecentArticlesError ? (
        <SectionWrapper>
          <GridContainer>
            <GridItem>
              <ProductCardSectionLayout
                error={recentArticlesError}
                sectionHeader={<SectionHeader>{t('profile.recentlyBoughtArticles')}</SectionHeader>}
              >
                {recentArticles?.map(
                  ({
                    id,
                    title,
                    itemDesc2,
                    itemDesc3,
                    gloss,
                    hexCode,
                    surface,
                    effect,
                    bonding,
                    series: { name, number, numberColor },
                    weatherResistance,
                    hasRendering,
                  }) => (
                    <ProductCard
                      key={id}
                      articleId={id}
                      bonding={bonding ?? undefined}
                      effect={effect ?? undefined}
                      gloss={gloss ?? undefined}
                      hasRendering={hasRendering}
                      hexCode={hexCode ?? '#fff'}
                      itemDesc2={itemDesc2}
                      itemDesc3={itemDesc3}
                      series={name}
                      seriesNumber={number}
                      seriesNumberColor={numberColor ?? undefined}
                      surface={surface ?? undefined}
                      title={title}
                      weatherResistance={weatherResistance ?? undefined}
                    />
                  ),
                )}
              </ProductCardSectionLayout>
            </GridItem>
          </GridContainer>
        </SectionWrapper>
      ) : null}
    </>
  );
};
